import { Ajax } from './axios'

export default {
    getresultPage (param = {}) {
      return Ajax.post('/api/gugongExaminee/v1/result/page', { ...param })
    },
    getresultDetail (id) {
      return Ajax.get(`/api/gugongExaminee/v1/result/detail/${id}`)
    },
    getNewsDetailGET (param = {}) {
      return Ajax.get(`/api/gugongExaminee/v1/common/news/getNewsDetail`, { ...param })
    }
  };
